import React from 'react';
const STEPS = [{
  num: '1',
  title: 'Get Your Free Quote',
  description: 'Call or book online. We provide fast, transparent pricing for your project.'
}, {
  num: '2',
  title: 'We Arrive On Time',
  description: 'Our uniformed crew arrives with professional-grade equipment ready to work.'
}, {
  num: '3',
  title: 'Sit Back & Shine',
  description: 'Relax while we deliver the royal treatment and transform your property.'
}];
export function Process() {
  return <section className="py-24 bg-[#081120] border-y border-electric/10" data-id="element-164">
      <div className="container mx-auto px-4" data-id="element-165">
        <div className="text-center mb-16" data-id="element-166">
          <h2 className="font-display text-4xl md:text-5xl text-white uppercase tracking-wide mb-4" data-id="element-167">
            How It <span className="text-gold" data-id="element-168">Works</span>
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row justify-center items-start gap-12 lg:gap-8 max-w-5xl mx-auto" data-id="element-169">
          {STEPS.map((step, idx) => <div key={idx} className="flex-1 flex flex-col items-center text-center relative w-full" data-id="element-170">
              {idx < STEPS.length - 1 && <div className="hidden lg:block absolute top-8 left-[60%] w-[80%] h-0.5 border-t border-dashed border-electric/50" data-id="element-171" />}
              <div className="relative z-10 w-16 h-16 rounded-full bg-navy border-2 border-electric flex items-center justify-center mb-6 shadow-[0_0_20px_rgba(28,160,232,0.3)]" data-id="element-172">
                <span className="font-display text-3xl text-white" data-id="element-173">
                  {step.num}
                </span>
                <div className="absolute -top-3 -right-2" data-id="element-174">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-175">
                    <path d="M2 22H22L19 4L15.5 10L12 2L8.5 10L5 4L2 22Z" fill="#F5B81E" stroke="#0A1628" strokeWidth="2" strokeLinejoin="round" data-id="element-176" />
                  </svg>
                </div>
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-177">
                {step.title}
              </h3>
              <p className="text-slate-400 max-w-xs" data-id="element-178">{step.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}